module.exports = __webpack_public_path__ + "media/images/ep6-cindy-540c5fcd6b2d9999dd25674bdaa298f0.png";